import * as BABYLON from "babylonjs";

export class AtmosphericScattering extends BABYLON.PostProcess {
    constructor(scene: BABYLON.Scene, engine: BABYLON.Engine) {
        super("Atmospheric Scattering", "./assets/earth/shaders/atmscat", ["screenSize", "cameraFOV", "cameraPosition", "lightInCam", "colorFactor"], [], 1.0, scene.activeCamera, BABYLON.Texture.BILINEAR_SAMPLINGMODE, engine, false);

        this.onApply = (effect) => {
            let camera = scene.activeCamera;
            let fov = camera.fov;
            effect.setFloat2("screenSize", engine.getRenderWidth(), engine.getRenderHeight());
            effect.setFloat("cameraFOV", fov);
            effect.setFloat3("cameraPosition", 0, 0, camera.position.length());
            effect.setFloat3("lightInCam", 0, 0, 1);
        };
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/atmosphericScattering.ts